module.exports = __webpack_public_path__ + "img/img_project_content3.2796671d.svg";